import { render, staticRenderFns } from "./WelcomeAlt.vue?vue&type=template&id=74845a16&"
import script from "./WelcomeAlt.vue?vue&type=script&lang=js&"
export * from "./WelcomeAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports